namespace SolovisGateway.Admin.Authentication {
    export class ExternalAuthAppModel {
        name: string;
        code: string;
        sharedSigningKey: string;
        globalAuthAllowed: boolean;
        loginUrl: string;
        logoutUrl: string;

        constructor(data: any) {
            if (data) {
                this.name = data.name;
                this.code = data.code;
                this.sharedSigningKey = data.sharedSigningKey;
                this.globalAuthAllowed = data.globalAuthAllowed;
                this.loginUrl = data.loginUrl;
                this.logoutUrl = data.logoutUrl;
            }
        }

        static initializeData(data: any) {
            data.globalAuthAllowed = false;
        }

        toDeleteParams(): { code: string } {
            return {
                code: this.code
            };
        }

        toGetOrgsParams(): { externalAuthAppCode: string } {
            return {
                externalAuthAppCode: this.code
            };
        }

        toAddParams(): { name: string, code: string, jwtSharedSigningKey: string, globalAuthAllowed: boolean, loginUrl: string, logoutUrl: string } {
            return {
                name: this.name,
                code: this.code,
                jwtSharedSigningKey: this.sharedSigningKey,
                globalAuthAllowed: this.globalAuthAllowed,
                loginUrl: this.loginUrl,
                logoutUrl: this.logoutUrl
            };
        }

        clearSensitiveData() {
            this.sharedSigningKey = null;
        }
    }
}